import { render, staticRenderFns } from "./BankDataPenelitian.vue?vue&type=template&id=7c5f7e78"
import script from "./BankDataPenelitian.vue?vue&type=script&lang=js"
export * from "./BankDataPenelitian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports